<template>
  <div class="min-h-screen">
    <!-- Header -->
    <AppHeader />
    <!-- Main Content -->
    <main>
      <slot />
    </main>

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script setup>
  import AppHeader from '@/components/AppHeader.vue'
  import AppFooter from '@/components/AppFooter.vue'

  // 默认布局，适用于所有页面
</script>

<style scoped>
  .min-h-screen {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  main {
    flex: 1;
  }
</style>
